module.exports = __webpack_public_path__ + "img/landing.cbf31a55.jpg";